export default __webpack_public_path__ + "static/media/header.0cb3d256.jpeg";